/*** IMPORTS FROM imports-loader ***/
var define = false;

var classof = require('../internals/classof-raw');
var global = require('../internals/global');

module.exports = classof(global.process) == 'process';

